const escapeHtml = (value) =>
  String(value || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

const fmtMoney = (value) => new Intl.NumberFormat("vi-VN").format(Math.round(Number(value) || 0));

export const getPrintTemplate = ({ data }) => {
  return `
  <html>
    <head>
      <meta charset="utf-8" />
      <title>Giấy Đề Nghị Thanh Toán</title>
      <style>
        @media print { @page { margin: 10mm; size: portrait; } }
        body { font-family: "Times New Roman", Times, serif; font-size: 16px; color: #000; padding: 18px; }
        .header { display:flex; justify-content:space-between; }
        .right { text-align:center; line-height: 1.25; }
        .title { margin: 12px 0 4px; text-align:center; font-size: 26px; font-weight: 700; text-transform: uppercase; }
        .date { text-align:center; margin-bottom: 10px; font-style: italic; }
        .row { margin-top: 8px; }
        .signatures { display:flex; justify-content:space-between; text-align:center; margin-top: 28px; }
        .sign-box { width: 24%; }
        .sign-spacer { height: 56px; }
        .italic { font-style: italic; }
        .page-number { position: fixed; right: 8mm; bottom: 6mm; font-size: 11px; }
      </style>
    </head>
    <body>
      <div class="header">
        <div>
          <div><b>Đơn vị:</b> ${escapeHtml(data.unit || "")}</div>
          <div><b>Địa chỉ:</b> ${escapeHtml(data.address || "")}</div>
        </div>
        <div class="right">
          <div><b>Mẫu số 05 - TT</b></div>
          <div><i>(Kèm theo Thông tư số 99/2025/TT-BTC</i></div>
          <div><i>ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)</i></div>
        </div>
      </div>

      <div class="title">GIẤY ĐỀ NGHỊ THANH TOÁN</div>
      <div class="date">Ngày ${escapeHtml(data.documentDate || ".../.../....")}</div>

      <div class="row" style="text-align:right;">Số: ${escapeHtml(data.documentNumber || "")}</div>

      <div class="row"><b>Kính gửi:</b> ${escapeHtml(data.recipient || "")}</div>
      <div class="row">Họ và tên người đề nghị thanh toán: ${escapeHtml(data.requesterName || "")}</div>
      <div class="row">Bộ phận (Hoặc địa chỉ): ${escapeHtml(data.requesterDepartmentAddress || "")}</div>
      <div class="row">Nội dung thanh toán: ${escapeHtml(data.paymentContent || "")}</div>
      <div class="row">Số tiền: ${fmtMoney(data.amountInNumber || 0)} <span class="italic">(Viết bằng chữ)</span>: ${escapeHtml(data.amountInWords || "")}</div>
      <div class="row" style="font-style: italic;">(Kèm theo ${escapeHtml(data.attachments || "")} chứng từ gốc).</div>

      <div class="signatures">
        <div class="sign-box">
          <div><b>Người đề nghị thanh toán</b></div>
          <div class="italic">(Ký, họ tên)</div>
          <div class="sign-spacer"></div>
        </div>
        <div class="sign-box">
          <div><b>Phụ trách bộ phận</b></div>
          <div class="italic">(Ký, họ tên)</div>
          <div class="sign-spacer"></div>
        </div>
        <div class="sign-box">
          <div><b>Kế toán trưởng</b></div>
          <div class="italic">(Ký, họ tên)</div>
          <div class="sign-spacer"></div>
        </div>
        <div class="sign-box">
          <div><b>Người duyệt</b></div>
          <div class="italic">(Ký, họ tên)</div>
          <div class="sign-spacer"></div>
        </div>
      </div>

      <div class="page-number">1/1</div>
      <script>window.onload=function(){window.print();}</script>
    </body>
  </html>`;
};
